import React from "react";
import { motion } from "framer-motion";
import AnimatedHeading from "./AnimatedHeading";
import useTilt from "../hooks/useTilt";

const PILLARS = [
    { n: "01", h: "Piattaforma software", b: "Il sistema con cui vendi, fatturi, gestisci clienti e adempimenti. Già configurato." },
    { n: "02", h: "Back-office",          b: "Operations giornaliera: switching, letture, anagrafiche, ARERA, SII. Ce ne occupiamo noi." },
    { n: "03", h: "Accounting & Legal",   b: "Contabilità dedicata, adempimenti fiscali, contrattualistica, GDPR. Coperto." },
    { n: "04", h: "IT & postalizzazione", b: "Infrastruttura, sicurezza, invio massivo di fatture e comunicazioni cartacee. Pronto." },
];

function PillarCard({ p }) {
    const tilt = useTilt({ max: 4 });
    return (
        <motion.div
            ref={tilt.ref}
            className="lp-pillar"
            data-testid={`pillar-${p.n}`}
            onMouseMove={tilt.onMouseMove}
            onMouseLeave={tilt.onMouseLeave}
            style={
                tilt.disabled
                    ? undefined
                    : {
                          rotateX: tilt.rotateX,
                          rotateY: tilt.rotateY,
                          transformPerspective: 900,
                          transformStyle: "preserve-3d",
                      }
            }
            variants={{
                hidden: { opacity: 0, y: 24 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
            }}
        >
            {!tilt.disabled && (
                <motion.span
                    className="lp-pillar-shine"
                    aria-hidden="true"
                    style={{ background: tilt.shineBackground }}
                />
            )}
            <span className="lp-pillar-num">{p.n}</span>
            <h3 className="lp-pillar-h">{p.h}</h3>
            <p className="lp-pillar-body">{p.b}</p>
        </motion.div>
    );
}

export default function SectionPillars() {
    return (
        <section className="lp-section lp-section-alt" aria-labelledby="s-pillars">
            <div className="lp-container">
                <div className="lp-section-head">
                    <motion.div
                        className="lp-eyebrow lp-section-eyebrow"
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <span className="lp-eyebrow-accent">02</span> &nbsp;/&nbsp; La soluzione
                    </motion.div>
                    <AnimatedHeading
                        as="h2"
                        id="s-pillars"
                        className="lp-h2"
                        text="Ti diamo la macchina intera."
                    />
                    <motion.p
                        className="lp-body-lg lp-section-sub"
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
                    >
                        Quattro pilastri, un unico interlocutore.
                    </motion.p>
                </div>
                <motion.div
                    className="lp-pillars"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ staggerChildren: 0.08 }}
                >
                    {PILLARS.map((p) => (
                        <PillarCard key={p.n} p={p} />
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
